var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLaunch = function SvgLaunch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9529 32.1014C11.9529 32.1014 36.6743 7.3054 38.2735 5.7085C40.0466 3.93316 45.7678 2.59601 48.6138 2.0223C48.7964 1.98547 48.9852 1.99437 49.1635 2.04819C49.3418 2.10201 49.504 2.19909 49.6357 2.33078C49.7674 2.46247 49.8645 2.62469 49.9183 2.80298C49.9721 2.98127 49.981 3.17011 49.9442 3.35267C49.3705 6.19863 48.0333 11.9177 46.258 13.693L19.9035 40.0452L11.9529 32.1014Z",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1379 28.8799L23.1021 36.8508",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8839 28.0693C31.9869 31.5511 31.7196 35.034 31.0866 38.4593C30.3314 40.2439 29.2463 41.87 27.8883 43.2523L22.2031 48.9284C22.0373 49.0951 21.8237 49.2059 21.5919 49.2454C21.3601 49.2849 21.1218 49.251 20.9102 49.1486C20.6986 49.0461 20.5242 48.8802 20.4114 48.6739C20.2986 48.4676 20.253 48.2313 20.281 47.9978L21.3855 38.5655",
    fill: "#0258FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8839 28.0693C31.9869 31.5511 31.7196 35.034 31.0866 38.4593C30.3314 40.2439 29.2463 41.87 27.8883 43.2523L22.2031 48.9284C22.0373 49.0951 21.8237 49.2059 21.5919 49.2454C21.3601 49.2849 21.1218 49.251 20.9102 49.1486C20.6986 49.0461 20.5242 48.8802 20.4114 48.6739C20.2986 48.4676 20.253 48.2313 20.281 47.9978L21.3855 38.5655",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8965 20.0825C20.3985 19.9532 16.8967 20.1963 13.45 20.8076C11.6835 21.5883 10.0804 22.6956 8.72484 24.0714L3.05551 29.7385C2.88896 29.9048 2.77853 30.1189 2.73964 30.351C2.70076 30.5832 2.73536 30.8216 2.83862 31.0331C2.94188 31.2446 3.10863 31.4186 3.31558 31.5307C3.52252 31.6428 3.75932 31.6874 3.99287 31.6584L13.4794 30.4974",
    fill: "#0258FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8965 20.0825C20.3985 19.9532 16.8967 20.1963 13.45 20.8076C11.6835 21.5883 10.0804 22.6956 8.72484 24.0714L3.05551 29.7385C2.88896 29.9048 2.77853 30.1189 2.73964 30.351C2.70076 30.5832 2.73536 30.8216 2.83862 31.0331C2.94188 31.2446 3.10863 31.4186 3.31558 31.5307C3.52252 31.6428 3.75932 31.6874 3.99287 31.6584L13.4794 30.4974",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1133 40.0458C16.7125 41.6427 16.0462 43.9059 14.316 45.6383C12.6965 47.2556 6.55738 49.1009 3.41553 49.9637C3.22525 50.0136 3.02526 50.0129 2.83534 49.9617C2.64542 49.9105 2.47218 49.8105 2.33275 49.6718C2.19332 49.533 2.09254 49.3603 2.0404 49.1706C1.98826 48.981 1.98656 48.781 2.03547 48.5905C2.88925 45.4396 4.71654 39.2824 6.32699 37.6606C8.082 35.9079 10.3226 35.2664 11.9195 36.8633",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLaunch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/launch.811fd774.svg";
export { ForwardRef as ReactComponent };